import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import './global.css';
import App from './App';

const rootElement = document.getElementById('root');

// Проверяем, была ли страница pre-rendered (react-snap)
if (rootElement.hasChildNodes()) {
  // Используем hydrate для pre-rendered страниц
  hydrateRoot(rootElement, <App />);
} else {
  // Обычный render для обычных страниц
  const root = createRoot(rootElement);
  root.render(<App />);
}
